export default __webpack_public_path__ + "static/media/IMPORT_DATA_PUBLIC.4b91e7f6.xlsx";